export default {
    breadcrumbs: {
        patient: 'Patient',
        patient_details: 'Patient Details',
        upload: 'Upload',
        upload_patients: 'Upload Patients',
        patient_list: 'Patient List',
    },

    titles: {
        patient_title: '{patientTitle} details',
        upload_title: '{uploadTitle} Patients List',
        patient_list_title: '{ListTitle} List',
    },
    buttons: {
        primary: 'Save',
        secondary: 'Cancel',
        export: 'Export',
        export_profile: 'Export Profile',
        edit_profile: 'Edit Profile',
    },
    button: {
        primary: 'Submit',
    },
    text: {
        export_txt: 'Please select the fields you want to Export',
        edit_txt: 'Please update the fields before Saving',
    },
}
